import { open_modal } from './modal'
import { bind_failure_section, failure_section_html } from './collection-load'
import {
  bind_submit_form,
  fetch_submit_dependencies,
  submit_form_html,
  submit_success_html,
  type SubmitResult
} from './submit-view'

function loading_body(): string {
  return `<div class="rounded-md border border-border bg-surface p-6 text-center text-sm text-muted">Carregando formulário…</div>`
}

function footer_success(): string {
  return `
    <div class="flex flex-wrap items-center justify-end gap-2">
      <button type="button" data-modal-close class="inline-flex h-9 items-center gap-2 rounded-md bg-ink px-3 text-xs font-bold uppercase tracking-wide text-canvas hover:opacity-90">Concluir</button>
    </div>`
}

export async function open_submit_modal(): Promise<void> {
  const handle = open_modal({
    size: 'xl',
    eyebrow: 'Publicar anúncio',
    title: 'Coloque seu anúncio no Classificado',
    body: loading_body(),
    footer: ''
  })

  // No footer until success — the form itself shows cost + buttons inline.
  handle.footer.classList.add('hidden')

  const wire_close = () => {
    handle.footer.querySelectorAll<HTMLButtonElement>('[data-modal-close]').forEach(btn => {
      btn.addEventListener('click', () => handle.close())
    })
  }

  try {
    const deps = await fetch_submit_dependencies()
    if (!handle.root.isConnected) return

    if (deps.failure) {
      handle.body.innerHTML = failure_section_html('o formulário de publicação', deps.failure)
      bind_failure_section(handle.body, () => {
        window.location.reload()
      })
      return
    }

    handle.body.innerHTML = submit_form_html({ variant: 'modal' })
    bind_submit_form(handle.body, {
      deps,
      on_cancel: () => handle.close(),
      on_success: (result: SubmitResult) => {
        if (!handle.root.isConnected) return
        handle.body.innerHTML = submit_success_html(result.short_code, result.owner_token)
        handle.footer.classList.remove('hidden')
        handle.footer.innerHTML = footer_success()
        wire_close()
      }
    })
  } catch {
    if (!handle.root.isConnected) return
    handle.body.innerHTML = `
      <div class="rounded-md border border-danger/40 bg-danger/10 px-4 py-5 text-center">
        <h3 class="font-serif text-lg font-bold text-danger">Não foi possível abrir o formulário</h3>
        <p class="mt-2 text-sm text-muted">Tente novamente em instantes.</p>
      </div>`
  }
}

function is_submit_link(anchor: HTMLAnchorElement): boolean {
  return anchor.getAttribute('href') === '/publicar'
}

let listener_installed = false
export function ensure_submit_modal_listener(): void {
  if (listener_installed) return
  listener_installed = true
  document.addEventListener('click', (event) => {
    const anchor = (event.target as HTMLElement | null)?.closest('a') as HTMLAnchorElement | null
    if (!anchor || !is_submit_link(anchor)) return
    const mouse = event as MouseEvent
    if (mouse.ctrlKey || mouse.metaKey || mouse.shiftKey || mouse.button === 1) return
    if (anchor.hasAttribute('target') || anchor.hasAttribute('download')) return
    event.preventDefault()
    event.stopPropagation()
    void open_submit_modal()
  }, true)
}
